<div class="pagination-wrapper">
  <div class='pagination banner-pagination'></div>
</div>
<button class='banner-prev' mat-icon-button>
  <mat-icon>keyboard_arrow_left</mat-icon>
</button>
<button class='banner-next' mat-icon-button>
  <mat-icon>keyboard_arrow_right</mat-icon>
</button>
        
<swiper [autoplay]="{delay: 5000}"
        [loop]="false"
        [ngClass]="{ 'displayer' : !isBannerLoaded}"
        [navigation]="bannerNavigation"
        [pagination]="bannerPagination"
        (indexChange)="selectedIndex = $event"
        style="border-radius: 10px; margin-top: 50px; overflow: hidden;">

  <ng-container>
  <ng-container *ngFor="let banner of dynamicBanners; let i = index">
    <ng-template swiperSlide>
      <div class="slide-container">
          <a [href]="selectedLanguage == 'ka' ? banner.deeplink : banner.deeplinkEng">
            <img (load)="isBannerLoaded = true" [src]="selectBannerImage(banner)" alt="{{ banner.title }}" />
          </a>
      </div>
    </ng-template>
  </ng-container>
</ng-container>
</swiper>

